require('./searchboxMap.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { SearchBox } = require('react-google-maps/lib/components/places/SearchBox');

class SearchBoxMap extends React.Component {
    onSetRefSearchBox = ref => {
        this._searchBox = ref;
    };

    onPlacesChanged = () => {
        const { onPlacesChanged } = this.props;
        const center = {
            lat: this._searchBox.getPlaces()[0].geometry.location.lat(),
            lng: this._searchBox.getPlaces()[0].geometry.location.lng(),
        };

        onPlacesChanged(center);
    };

    render() {
        return (
            <SearchBox
                bounds={null}
                ref={this.onSetRefSearchBox}
                controlPosition={google.maps.ControlPosition.TOP_LEFT}
                onPlacesChanged={() => this.onPlacesChanged()}
            >
                <input type="text" placeholder="Buscador" className="search-box" />
            </SearchBox>
        );
    }
}

SearchBoxMap.propTypes = {
    onPlacesChanged: PropTypes.func.isRequired,
};

export { SearchBoxMap };
